import { isProd } from "client/config";

export const CAPTCHA_SITE_KEY = "6LfxOyElAAAAAKpdVNO7fIPiE7LwPq02-6mUiNnE";
export const TEST_CAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

export const getCaptchaSiteKey = (): string =>
  window.Cypress ? TEST_CAPTCHA_SITE_KEY : CAPTCHA_SITE_KEY;

export const isCaptchaApproved = (isCaptchaChecked: boolean): boolean =>
  isCaptchaChecked || !isProd;
